<template>
  <!--skills-area-start-->
  <div class="skills-area" style="background-image: url(assets/img/contact.png)">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="skills-img">
            <img src="assets/img/skille.png" alt="" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="skills-containt">
            <div class="skills-logo">
              <a href="#"><img src="assets/img/logo-skills.png" alt=""/></a>
            </div>
            <div class="skills-title">
              <h3>{{ article.title }}</h3>
              <p class="skills-subtitle pb-2">{{ article.subTitle }}</p>
            </div>
            <div class="row">
              <div class="col-md-6" v-for="(item, i) in article.content" :key="'skill' + i">
                <div class="skills-text">
                  <img :src="`assets/img/a${i + 1}.png`" alt="" />
                  <p>{{ item.text }}</p>
                </div>
              </div>
            </div>
            <div class="skills-btn">
              <p>Emerging skills provides face to face, distant or blended formats.</p>
              <router-link to="/emerging-skills" class="theme-btn" target="_new"
                >Learn more</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--skills-area-end-->
</template>

<script>
import { getArticleById } from '@/api/navItems';
import { translate } from '@/lib/utils';
export default {
  mounted() {
    let articleId = '5fb503b54939016cbf4a32f2';
    getArticleById(articleId).then(res => {
      this.article = translate(res);
    });
  },
  data() {
    return {
      article: {}
    };
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
p.skills-subtitle {
  font-size: 18px;
  font-weight: 300;
}
</style>
